export default __webpack_public_path__ + "static/media/5.3a98d9be.png";